import styled from "styled-components"
import { cssMediaQueryBreakpoints } from "../../../config/breakpoints"

export const SearchInput = styled.input`
  ${cssMediaQueryBreakpoints.medium} {
    font-size: 14px;
  }

  outline: none;
  width: 100%;
  border: none;
  font-size: 16px;
  color: ${p => p.theme.textColor};
  background: none;
  font-family: inherit;

  ::placeholder {
    color: ${p => p.theme.textColor};
    opacity: 0.6;
    font-family: inherit;
  }
`
